/**
 * Centralized configuration for clinic-specific images.
 * This allows for easy switching or removal of images across the site.
 * Set 'enabled' to false to revert to the default placeholders/icons.
 */

export const clinicImages = {
    hero: {
        enabled: true,
        url: "/images/2025-10-15.webp",
        alt: { en: "Professional Dental Tools", ar: "أدوات أسنان احترافية" },
    },
    team: {
        enabled: true,
        url: "/images/2025-08-30.webp",
        alt: { en: "Primero Clinic Staff Team", ar: "فريق عمل عيادة بريميرو" },
    },
    pediatric: {
        enabled: true,
        url: "/images/2025-09-18.webp",
        alt: { en: "Happy Pediatric Patient", ar: "مريض أطفال سعيد" },
    },
    doctorPatient: {
        enabled: true,
        url: "/images/2026-01-29.webp",
        alt: { en: "Doctor with Patient", ar: "طبيب مع مريض" },
    },
    doctorKid: {
        enabled: true,
        url: "/images/2025-05-14.webp",
        alt: { en: "Doctor with Kid", ar: "طبيب مع طفل" },
    }
};

export type ClinicImageKey = keyof typeof clinicImages;
